import { render } from "./BrandApprovalDetail.vue?vue&type=template&id=48ff32bc"
import script from "./BrandApprovalDetail.vue?vue&type=script&lang=js"
export * from "./BrandApprovalDetail.vue?vue&type=script&lang=js"

import "./BrandApprovalDetail.vue?vue&type=style&index=0&id=48ff32bc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__